export default __webpack_public_path__ + "static/media/twitter.980b89b5.svg";